import type { ApiOrder, OrderStatus, PaymentType, ServiceModel } from '../../core/api/api.types';
import { ORDER_STATUS_LABELS, PAYMENT_TYPE_LABELS, SERVICE_MODEL_LABELS } from '../../core/api/api.types';

export type CaseListItem = {
  id: string;
  name: string;
  caseCode: string;
  status: string;
  initials: string;
  selected?: boolean;
  unreadCount: number;
};

export type LiveOrder = ApiOrder & {
  editMode: boolean;
  providerDisplayText: string;
  scheduledDateObj: Date | null;
  scheduledTimeStr: string;
  scheduledTimeDateObj: Date | null;
};

export type CreateOrderDraft = {
  service_model: ServiceModel | '';
  category: string;
  service_name: string;
  scheduledDate: Date | null;
  scheduledTime: Date | null;
  providerDisplayText: string;
  provider_assignment_type: 'unassigned' | 'assigned' | 'unknown' | 'other_in_notes';
  provider_id: string | null;
  address: string;
  address_access_notes: string;
  internal_notes: string;
  payment_type: PaymentType | '';
  quote_amount: number | null;
  estimated_duration_minutes: number | null;
  completion_notes: string;
  cancelled_reason: string;
};

export const ORDER_STATUS_OPTIONS: Array<{ value: OrderStatus; label: string }> = (
  Object.entries(ORDER_STATUS_LABELS) as [OrderStatus, string][]
).map(([value, label]) => ({ value, label }));

export const SERVICE_MODEL_OPTIONS: Array<{ value: ServiceModel; label: string }> = (
  Object.entries(SERVICE_MODEL_LABELS) as [ServiceModel, string][]
).map(([value, label]) => ({ value, label }));

export const PAYMENT_TYPE_OPTIONS: Array<{ value: PaymentType; label: string }> = (
  Object.entries(PAYMENT_TYPE_LABELS) as [PaymentType, string][]
).map(([value, label]) => ({ value, label }));
